module.exports = __webpack_public_path__ + "static/img/4620_phase_function_Paper_Points.d36a5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4620_phase_function_Paper_Points.png
// module id = QFrX
// module chunks = 0